// promise-обертка над setTimeout
// ms: number - количество миллисекунд
export default function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
